export default "__VITE_ASSET__lFcwEYD2__"